module.exports = __webpack_public_path__ + "img/Wevent_Logo_only_text_black.5b51ce7a.svg";